import { render, staticRenderFns } from "./EnergySubArea.vue?vue&type=template&id=8042aad2&scoped=true&"
import script from "./EnergySubArea.vue?vue&type=script&lang=js&"
export * from "./EnergySubArea.vue?vue&type=script&lang=js&"
import style0 from "./EnergySubArea.vue?vue&type=style&index=0&id=8042aad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8042aad2",
  null
  
)

export default component.exports